/**
 * Prefixed key/value storage helpers ported from lpr-web (`browserStorageCRUD`).
 * Keys are namespaced with `__` to match the values written by the original app.
 */
type StorageType = "localStorage" | "sessionStorage"

const isBrowser = typeof window !== "undefined"

export function getParamsFromStorage(
  params: string[],
  type: StorageType = "localStorage",
): Record<string, string> {
  const result: Record<string, string> = {}
  if (!isBrowser) return result
  try {
    params.forEach((key) => {
      const value = window[type].getItem("__" + key)
      if (value) result[key] = value
    })
  } catch (e) {
    console.error(`[storage-params] read from ${type} failed:`, e)
  }
  return result
}

export function setParamsToStorage(
  params: Record<string, string>,
  type: StorageType = "localStorage",
): void {
  if (!isBrowser) return
  try {
    Object.entries(params).forEach(([key, value]) => {
      window[type].setItem("__" + key, value)
    })
  } catch (e) {
    console.error(`[storage-params] write to ${type} failed:`, e)
  }
}
